/**
 *
 * Asynchronously loads the component for ResetPasswordForm
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "ResetPasswordForm" */),
  loading: <Loading />
})
